/* eslint-disable */

import React, { Component } from 'react';
import vSpeed from '@baidu/mvideo-vspeed';
import { get } from '@baidu/mvideo-tool';
import './index.less';
// 定位代码行提示蒙层
import { Inspector } from 'react-dev-inspector';

const InspectorWrapper = process.env.NODE_ENV === 'development'
    ? Inspector
    : React.Fragment;

    
class Layout extends Component {
    componentDidMount() {
        if (
            !(
                get(window.vSpeedConfig, 'on', false)
                && get(window.vSpeedConfig, 'autoFMP', false)
            )
        ) {
            return;
        }
        vSpeed.listenFmpByAuto(document.getElementById('root'));
        setTimeout(() => {
            vSpeed.sendCount({ group: 'bml_all' });
            vSpeed.sendDist({ group: 'bml_all' });
        }, 1000);
    }

    render() {
        return (
            <InspectorWrapper
                // 指令名称control+shift+c开启debug模式
                keys={['control', 'shift', 'c']
                }
            >
                <div className="main">
                    {this.props.children}
                </div>
            </InspectorWrapper>
        );
    }
}

export default Layout;